import { MapperInterface } from "@app/shared/mapper/mapper-inteface";
import { Injectable } from "@angular/core";
import { MapperSettore } from "./mapper-settore";

import { StatoNotaEnum } from "../enum/stato-nota-enum";
import { MapperUtente } from "./mapper-utente";
import { FiltroRicercaNotaDTO } from "../dto/filtro-ricerca-notaDTO";
import { FiltroRicercaNotaVO } from "../vo/filtro-ricerca-notaVO";

@Injectable({
  providedIn: "root",
})
export class MapperFiltroRicercaNota
  implements MapperInterface<FiltroRicercaNotaDTO, FiltroRicercaNotaVO> {
  constructor(
    private mapperSettore: MapperSettore,
    private mapperUtente: MapperUtente
  ) {}

  convertVoToDto(vo: FiltroRicercaNotaVO): FiltroRicercaNotaDTO {
    if (vo != null) {
      const dto = new FiltroRicercaNotaDTO();
      dto.settore = this.mapperSettore.convertVoToDto(vo.settore);
      dto.ricercaSemplice = vo.ricercaSemplice;
      dto.oggetto = vo.oggetto;
      dto.dataInserimentoAl = vo.dataInserimentoAl;
      dto.dataInserimentoDal = vo.dataInserimentoDal;
      dto.numeroRepertorio = vo.numeroRepertorio;
      dto.annoRepertorio = vo.annoRepertorio;
      dto.dataRepertoriazioneDal = vo.dataRepertoriazioneDal;
      dto.dataRepertoriazioneAl = vo.dataRepertoriazioneAl;
      dto.dataApprovazioneDal = vo.dataApprovazioneDal;
      dto.dataApprovazioneAl = vo.dataApprovazioneAl;
      dto.lineaFinanziamento = vo.lineaFinanziamento;
      dto.tipologiaNota = vo.tipologiaNota;
      dto.beneficiario = vo.beneficiario;
      dto.codiceCor = vo.codiceCor;
      dto.presaInCarico = vo.presaInCarico;
      dto.estensore = this.mapperUtente.convertVoToDto(vo.estensore);
      dto.responsabile = this.mapperUtente.convertVoToDto(vo.responsabile);
      dto.pageNumber = vo.pageNumber;
      dto.sort = vo.sort;
      dto.direz = vo.direz;
      dto.stato = <StatoNotaEnum[]>(
        (vo.stato === null || vo.stato === undefined || Array.isArray(vo.stato)
          ? vo.stato
          : [vo.stato])
      );
      switch (vo.statoDaEscludere) {
        case "BOZZA":
          dto.statoDaEscludere = StatoNotaEnum.BOZZA;
          break;
      }
      return dto;
    } else {
      return null;
    }
  }

  convertDtoToVo(dto: FiltroRicercaNotaDTO): FiltroRicercaNotaVO {
    if (dto != null) {
      const vo = new FiltroRicercaNotaVO();
      // TODO fare mapper questa riga funge solo se DTO e VO sono identici
      // vo = JSON.parse(JSON.stringify(dto));

      return vo;
    } else {
      return null;
    }
  }

  convertListVoToDto(voList: FiltroRicercaNotaVO[]): FiltroRicercaNotaDTO[] {
    if (voList != null) {
      return voList.map((vo) => this.convertVoToDto(vo));
    } else {
      return null;
    }
  }

  convertListDtoToVo(dtoList: FiltroRicercaNotaDTO[]): FiltroRicercaNotaVO[] {
    if (dtoList != null) {
      return dtoList.map((dto) => this.convertDtoToVo(dto));
    } else {
      return null;
    }
  }
}
